var scrollbarWidth;

SVGElement.prototype.hasClass = function (className) {
    return new RegExp('(\\s|^)' + className + '(\\s|$)').test(this.getAttribute('class'));
};


SVGElement.prototype.addClass = function (className) {
    if (!this.hasClass(className)) {
        this.setAttribute('class', this.getAttribute('class') + ' ' + className);
    }
};


SVGElement.prototype.removeClass = function (className) {
    var removedClass = this.getAttribute('class').replace(new RegExp('(\\s|^)' + className + '(\\s|$)', 'g'), '$2');
    if (this.hasClass(className)) {
        this.setAttribute('class', removedClass);
    }
};


SVGElement.prototype.toggleClass = function (className) {
    if (this.hasClass(className)) {
        this.removeClass(className);
    } else {
        this.addClass(className);
    }
};


var lastTime = 0;
var vendors = ['ms', 'moz', 'webkit', 'o'];
for (var x = 0; x < vendors.length && !window.requestAnimationFrame; ++x) {
    window.requestAnimationFrame = window[vendors[x] + 'RequestAnimationFrame'];
    window.cancelAnimationFrame = window[vendors[x] + 'CancelAnimationFrame'] || window[vendors[x] + 'CancelRequestAnimationFrame'];
}
if (!window.requestAnimationFrame) {
    window.requestAnimationFrame = function (callback, element) {
        var currTime = new Date().getTime();
        var timeToCall = Math.max(0, 16 - (currTime - lastTime));
        var id = window.setTimeout(function () {
            callback(currTime + timeToCall);
        }, timeToCall);
        lastTime = currTime + timeToCall;

        return id;
    };
}

if (!window.cancelAnimationFrame) {
    window.cancelAnimationFrame = function (id) {
        clearTimeout(id);
    };
}

jQuery.fn.serializeObject = function () {
    var arrayData;
    var objectData;
    arrayData = this.serializeArray();
    objectData = {};

    $.each(arrayData, function () {
        var value;
        var name = this.name.slice(-2) == '[]' ? this.name.slice(0, -2) : this.name;

        if (this.value != null) {
            value = this.value;
        } else {
            value = '';
        }

        if (objectData[name] != null) {
            if (!objectData[name].push) {
                objectData[name] = [objectData[name]];
            }

            objectData[name].push(value);
        } else {
            objectData[name] = value;
        }
    });

    return objectData;
};


//escaping all control symbols inside Media Base Url to use it as regular expression + check url ends with file extension: \.\w{2, 7}$  (.ai, .mp4, .sketch, etc..)
var mediaUrlRegex = new RegExp('^' + app.settings.mediaUrl.replace(/[-/\\^$*+?.()|[\]{}]/g, '\\$&') + '.*\\.\\w{2,7}$');
var originUrlRegex = new RegExp('^' + window.location.origin.replace(/[-/\\^$*+?.()|[\]{}]/g, '\\$&'));

// Generate unique cid for object
//
var _cid = 0;


module.exports = {

        PageVisibilityManager: function() {
            // Set the name of the hidden property and the change event for visibility
            var hidden, visibilityChange;
            if (typeof document.hidden !== "undefined") {
                hidden = "hidden";
                visibilityChange = "visibilitychange";
            } else if (typeof document.mozHidden !== "undefined") {
                hidden = "mozHidden";
                visibilityChange = "mozvisibilitychange";
            } else if (typeof document.msHidden !== "undefined") {
                hidden = "msHidden";
                visibilityChange = "msvisibilitychange";
            } else if (typeof document.webkitHidden !== "undefined") {
                hidden = "webkitHidden";
                visibilityChange = "webkitvisibilitychange";
            }

            var add = function(callback) {
                if (!hidden) { return false; }
                document.addEventListener(visibilityChange, callback);
            };

            var remove = function(callback) {
                if (!hidden) { return false; }
                document.removeEventListener(visibilityChange, callback);
            };

            var isHidden = function() {
                return document[hidden];
            };

            return {
                addEventListener : add,
                removeEventListener: remove,
                isPageHidden: isHidden
            };
        }(),

    //fix safari 12 bug, css :checked selector doesn't cause repaint on radio input change
    fixSafariRadioRepaint: function (e) {
        var $icon = $(e.currentTarget)
            .parent()
            .find('label');

        $icon.css({
            'display': 'none',
            'visibility': 'hidden' //special case when display is set in css with !important
        });

        $icon.outerHeight();

        $icon.css({
            'display': '',
            'visibility': ''
        });
    },


    cid: function (data) {
        if (typeof data !== 'undefined') {
            return Object.assign({}, data, {_cid: data._cid || ++_cid});
        }

        return ++_cid;
    },


    isValidEmail: function (email) {
        var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

        return re.test(email);
    },


    scrollOnDrag: function (params) {

        var Handler = function (params) {
            this.params = params;

            this.$scrollContent = $(this.params.scrollInstance.getContentPane());
            this.$scrollWrapper = this.$scrollContent.parent();
        };


        Handler.prototype = {
            initialize: function () {
                if (app.settings.isDesktop) {
                    this.params.sortInstance.on('sort', this.onSort.bind(this));
                }
            },

            onSort: function (e, data) {
                var scrollAreaTop = -this.$scrollContent.position().top;
                var scrollAreaHeight = this.$scrollWrapper.height();
                var scrollAreaBottom = scrollAreaTop + this.$scrollWrapper.height();

                if (data.position.top < scrollAreaTop) {
                    this.params.scrollInstance.scrollToY(data.position.top - 10);
                    this.params.sortInstance.sortable('refreshPositions');
                } else if (data.position.top > scrollAreaBottom) {
                    this.params.scrollInstance.scrollToY(data.position.top + 10 - scrollAreaHeight);
                    this.params.sortInstance.sortable('refreshPositions');
                }
            },


            destroy: function () {
                this.params.sortInstance.off('sort');
            }
        };

        var handler = new Handler(params);

        handler.initialize();

        return handler;
    },


    phoneInputHandler: function (params) {

        var Handler = function (params) {
            this.params = params;
        };


        Handler.prototype = {
            initialize: function () {
                this.onPhoneInput = this.onPhoneInput.bind(this);
                this.params.phone0.on('input', this.onPhoneInput);
                this.params.phone1.on('input', this.onPhoneInput);
            },

            onPhoneInput: function (e) {
                var $input = $(e.currentTarget);
                var prevVal = $input.attr('data-prev') || '';
                var newVal = $input.val();

                if (newVal.length > prevVal.length && newVal.length >= 3) {
                    if ($input.is(this.params.phone0)) {
                        this.params.phone1.focus();
                    } else {
                        this.params.phone2.focus();
                    }
                }

                $input.attr('data-prev', newVal);
            },


            destroy: function () {
                this.params.phone0.off('input', this.onPhoneInput);
                this.params.phone1.off('input', this.onPhoneInput);
            }
        };

        var handler = new Handler(params);

        handler.initialize();

        return handler;
    },


    timeInputHandler: function (params) {

        var Handler = function (params) {
            this.params = params;
        };


        Handler.prototype = {
            initialize: function () {
                this.onTimeInput = this.onTimeInput.bind(this);
                this.params.time0.on('input', this.onTimeInput);
                this.params.time1.on('input', this.onTimeInput);
                this.params.time2.on('input', this.onTimeInput);
            },

            onTimeInput: function (e) {
                var $input = $(e.currentTarget);

                $input
                    .val($input
                            .val()
                            .replace(/[^\d]+/g,'')
                            .slice(0, 2)
                    );

                var prevVal = $input.attr('data-prev') || '';
                var newVal = $input.val();


                if (newVal.length > prevVal.length && newVal.length >= 2) {
                    if ($input.is(this.params.time0)) {
                        this.params.time1.focus();
                    } else if ($input.is(this.params.time1)) {
                        this.params.time2.focus();
                    }
                }

                $input.attr('data-prev', newVal);
            },


            destroy: function () {
                this.params.time0.off('input', this.onTimeInput);
                this.params.time1.off('input', this.onTimeInput);
            }
        };

        var handler = new Handler(params);

        handler.initialize();

        return handler;
    },

    updateLinksAttributes: function ($container) {
        $('a', $container).each(function () {
            var $link = $(this);

            if ($link.hasClass('u-skipUrlParser')) return;

            var href = $link.attr('href');
            var linkType = 'inner';

            if (/\.\w{2,7}$/i.test(href)) linkType = 'file';
            if (/^tel\:/i.test(href)) linkType = 'tel';
            if (/^mailto\:/i.test(href)) linkType = 'mail';
            if (/^http/i.test(href)) linkType = 'outer';
            if (originUrlRegex.test(href)) {
                $link.attr('href', href.substring(window.location.origin.length));
                linkType = 'inner';
            }
            if (/^#/i.test(href)) linkType = 'anchor';
            if (mediaUrlRegex.test(href)) linkType = 'file'; //in case of mediaUrl starts with http and "/^http/i" conditional statement overrides file conditional statement "/\.\w{2,7}$/i"

            if (linkType == 'outer' || linkType == 'file') {
                $link.attr('target', '_blank');
            } else {
                $link.removeAttr('target');
            }

            $link.toggleClass('u-Outer', linkType == 'outer');
            $link.toggleClass('u-Route', linkType == 'inner');
            $link.toggleClass('u-Tel', linkType == 'tel');
            $link.toggleClass('u-Mail', linkType == 'mail');
            $link.toggleClass('u-File', linkType == 'file');
            $link.toggleClass('u-Anchor', linkType == 'anchor');

            if (linkType == 'file') {
                $link.attr('data-type', href.match(/\.(\w{2,7})$/i)[1]);
            }
        });
    },


    createEmptyPromise: function () {
        return new Promise(function (resolve) {
            resolve();
        });
    },


    getFocusBack: function () {
        $('<input style="position: absolute;left: -999px;font-size:20px" type="text"/>')
            .appendTo('body')
            .css({'top': $(window).scrollTop()})
            .focus()
            .remove();
    },

    waitForTransitionEnd: function ($obj, property, cb, safeTimeout) {

        var transEndEventNames = {
            'transition'       : 'transitionend',
            'WebkitTransition' : 'webkitTransitionEnd',
            'MozTransition'    : 'transitionend',
            'OTransition'      : 'oTransitionEnd',
            'msTransition'     : 'MSTransitionEnd'
        };

        var getTransitionEndName = function () {
            if (!window.getComputedStyle || !document.documentElement) {
                return 'transitionend';
            }

            var styles = window.getComputedStyle(document.documentElement, '');

            for (var i in transEndEventNames) {
                if (styles[i] != undefined) {
                    return transEndEventNames[i];
                }
            }

            return 'transitionend';
        };

        var transEndEventName = getTransitionEndName();

        var transitionEndCallback = function (e) {

            if (e) {
                var prop = e.originalEvent.propertyName.toLowerCase();
                if (!$(e.target).is($obj)) return;
                if (prop.indexOf(property) == -1) return;
            }

            $obj.off(transEndEventName, transitionEndCallback);

            clearTimeout(transitionSafeTimeout);

            cb();
        };

        var resetAllHandlers = function () {
            $obj.off(transEndEventName, transitionEndCallback);

            clearTimeout(transitionSafeTimeout);
        };


        //������� ������� ��������� ��������, ��� ���� �������� ����������� �� applyTransform && applyTransition
        //���������� �� ��� ������� ����� (��� ������ ������ � ���� ����� ����������) �� �����
        //�������� �� iOS ������������ ����� ��� ������� webkitTransitionEnd � transitionend
        //� .on ��������� ��� �����, � ��� ������� ������� � ���, ��� Transition End ���������� �������� ��� ������� ������������ ��������
        $obj.on(transEndEventName, transitionEndCallback);

        //������ ������������, �� ������ ���� transitionend ������ �� ��������� (���� ������� ��� ������� ��� ����������)
        var transitionSafeTimeout = setTimeout(transitionEndCallback, safeTimeout == undefined ? this.getTransitionDuration($obj[0], property) + 100 : safeTimeout);

        return resetAllHandlers;
    },



    getScrollbarWidth: function () {
        if (scrollbarWidth != undefined) {
            return scrollbarWidth;
        }

        var outer = document.createElement('div');
        outer.style.visibility = 'hidden';
        outer.style.width = '100px';
        outer.style.msOverflowStyle = 'scrollbar'; // needed for WinJS apps

        document.body.appendChild(outer);

        var widthNoScroll = outer.offsetWidth;
        // force scrollbars
        outer.style.overflow = 'scroll';

        // add innerdiv
        var inner = document.createElement('div');
        inner.style.width = '100%';
        outer.appendChild(inner);

        var widthWithScroll = inner.offsetWidth;

        // remove divs
        outer.parentNode.removeChild(outer);

        scrollbarWidth = widthNoScroll - widthWithScroll;

        return scrollbarWidth;
    },


    queryUrlGetParam: function (variable, url) {
        if (!url) {
            return '';
        }

        try {
            var queryParts = url.split('?');
            var query = queryParts[queryParts.length - 1];

            if (!query) {
                return '';
            }

            var v = query.split('&');
            for (var i = 0; i < v.length; i++ ) {
                var p = v[i].split('=');
                if (p[0] == variable) {
                    if (p.length > 1) {
                        return decodeURIComponent(p[1]);
                    } else {
                        return ''; //if variable for empty param, without value
                    }
                }
            }
        } catch (e) {
            console.log(e);
        }
    }
};



//////////////////
// WEBPACK FOOTER
// ./assets/app/front/utils/Utils.js
// module id = 35
// module chunks = 0